import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import StartHere from './pages/StartHere';
import Framework from './pages/Framework';
import Services from './pages/Services';
import Book from './pages/Book';
import Resources from './pages/Resources';
import ResourceDetail from './pages/ResourceDetail';
import GuideDownload from './pages/GuideDownload';
import MyLibrary from './pages/MyLibrary';
import Assessment from './pages/Assessment';
import Contact from './pages/Contact';
import Newsletter from './pages/Newsletter';
import Verify from './pages/Verify';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

// Admin Pages
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminResourceList from './pages/admin/ResourceList';
import AdminResourceEditor from './pages/admin/ResourceEditor';

import './App.css';

function App() {
  return (
    <HelmetProvider>
      <HashRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/start-here" element={<StartHere />} />
          <Route path="/safe-ai-framework" element={<Framework />} />
          
          {/* Renamed Services to Work With Us */}
          <Route path="/work-with-us" element={<Services />} />
          <Route path="/services" element={<Navigate to="/work-with-us" replace />} />

          {/* Resource Routes */}
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:slug" element={<ResourceDetail />} />
          <Route path="/resources/guide" element={<GuideDownload />} />

          {/* Legal & Static Routes */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Other Routes */}
          <Route path="/shop" element={<Navigate to="/resources" replace />} />
          <Route path="/checkout-success" element={<Success />} />
          <Route path="/checkout-cancel" element={<Cancel />} />
          <Route path="/book" element={<Book />} />
          <Route path="/library" element={<MyLibrary />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/verify" element={<Verify />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
          <Route path="/admin/resources" element={<AdminLayout><AdminResourceList /></AdminLayout>} />
          <Route path="/admin/resources/new" element={<AdminLayout><AdminResourceEditor /></AdminLayout>} />
          <Route path="/admin/resources/edit/:id" element={<AdminLayout><AdminResourceEditor /></AdminLayout>} />

          {/* Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </HashRouter>
    </HelmetProvider>
  );
}

export default App;